<ciao-modal
  #checkpointModal
  [title]="'I\'m Okay Alert'"
  [preventBackdropClosing]="true"
>
  <div modalBody class="modal-body">
    <div class="success-overlay" *ngIf="showSuccess">
      <svg class="success-check" viewBox="0 0 52 52" aria-hidden="true">
        <circle class="success-check__circle" cx="26" cy="26" r="24" />
        <path class="success-check__mark" fill="none" d="M14 27l8 8 16-16" />
      </svg>
      <p class="success-message">I'm Okay submitted!</p>
    </div>

    <div class="datetime-display">
      <span class="datetime-label">Current Date &amp; Time</span>
      <span class="datetime-value">{{ currentDateTimeDisplay }}</span>
    </div>

    <ng-container *ngIf="requiresTripSelection">
      <ciao-form-field
        class="form-field"
        label="Choose Trip"
        type="combobox"
        [selectOptions$]="openAndLateTrips$"
        [formControlInput]="formGroup.controls.tripId"
      ></ciao-form-field>
    </ng-container>

    <ng-container *ngIf="!requiresTripSelection || formGroup.controls.tripId.value">
      <!-- Bordered "act now" block so the in-window check-ins and the submit
           action read as one clear group. -->
      <div class="okay-block">
        <!-- Check-ins this submission will satisfy (past-due or in the window) -->
        <section
          *ngIf="inWindowCheckpoints.length > 0"
          class="section section--checkpoints"
        >
          <h3 class="section-title">
            Scheduled check-ins
            <span class="section-title-note">(within 3 hours)</span>
          </h3>
          <ul class="checkpoint-list">
            <li
              *ngFor="let cp of inWindowCheckpoints"
              class="checkpoint-item"
              [ngClass]="'checkpoint-item--' + getCheckpointStatusType(cp)"
            >
              <ng-container
                [ngTemplateOutlet]="checkpointRow"
                [ngTemplateOutletContext]="{ $implicit: cp }"
              ></ng-container>
            </li>
          </ul>
        </section>

        <div
          *ngIf="inWindowCheckpoints.length > 0"
          class="modal-divider"
          aria-hidden="true"
        ></div>

        <section class="section section--form">
          <ciao-form-field
            class="form-field"
            label="Notes"
            type="text"
            [formControlInput]="formGroup.controls.notes"
          ></ciao-form-field>
        </section>

        <div class="footer-actions">
          <button
            class="btn-submit"
            [disabled]="shouldDisableSubmit"
            (click)="sendOkay()"
          >
            Submit I'm Okay
          </button>
        </div>
      </div>

      <!-- Upcoming alerts outside the window: shown for reference only -->
      <section
        *ngIf="upcomingCheckpoints.length > 0"
        class="section section--checkpoints section--upcoming"
      >
        <h3 class="section-title">Upcoming alerts</h3>
        <ul class="checkpoint-list">
          <li
            *ngFor="let cp of upcomingCheckpoints"
            class="checkpoint-item"
            [ngClass]="'checkpoint-item--' + getCheckpointStatusType(cp)"
          >
            <ng-container
              [ngTemplateOutlet]="checkpointRow"
              [ngTemplateOutletContext]="{ $implicit: cp }"
            ></ng-container>
          </li>
        </ul>
      </section>
    </ng-container>
  </div>

  <!-- Empty footer: actions live in the body, and this suppresses the shell's
       default Cancel/Confirm buttons (rendered only when the slot is empty). -->
  <span modalFooter></span>
</ciao-modal>

<!-- Inner cells only; the <li> wrapper lives on each <ul>'s *ngFor so the list
     item sits directly inside its list container. -->
<ng-template #checkpointRow let-cp>
  <img
    class="checkpoint-icon"
    [src]="getCheckpointStatusIcon(cp)"
    [alt]="getCheckpointStatusLabel(cp) + ' status'"
    [title]="getCheckpointStatusLabel(cp)"
  />
  <span class="checkpoint-description">{{ cp.description }}</span>
  <span class="checkpoint-date">{{ formatCheckpointDate(cp.expectedTime) }}</span>
  <span class="checkpoint-time">{{ formatCheckpointTimeOnly(cp.expectedTime) }}</span>
</ng-template>
